import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 20 24"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "#000",
      d: "M10 23.375q-.14 0-.352-.059a1.8 1.8 0 0 1-.421-.164q-2.45-1.395-4.149-2.46-1.687-1.067-2.719-2.063Q1.34 17.62.871 16.46q-.457-1.172-.457-2.754V4.871q0-.902.387-1.3.387-.411 1.113-.704.411-.165 1.125-.433.715-.282 1.57-.598.868-.328 1.723-.633Q7.2.887 7.914.641 8.63.383 9.04.242q.235-.07.469-.117a2.6 2.6 0 0 1 .984 0q.246.046.48.117.41.141 1.114.399.714.246 1.57.562.867.316 1.723.633.867.316 1.582.586t1.125.445q.738.305 1.113.703.387.4.387 1.301v8.836q0 1.582-.445 2.777-.445 1.185-1.465 2.215-1.008 1.032-2.707 2.086-1.688 1.055-4.196 2.367a1.7 1.7 0 0 1-.433.164q-.2.06-.34.059m-4.348-7.3q0 1.323 1.23 1.323h6.259q1.242 0 1.242-1.324V11.27q0-1.253-1.067-1.324V8.527q0-1.675-.914-2.695t-2.39-1.02q-1.478 0-2.39 1.02-.915 1.02-.915 2.695v1.418q-1.055.07-1.055 1.325zm2.32-6.141V8.387q0-1.055.563-1.7.562-.656 1.477-.656.926 0 1.476.657.563.645.563 1.699v1.547z"
    }, null, -1)
  ]))]))
}
export default { render: render }